// App.js (MODIFIED — nothing deleted, only added)
// ✅ Adds Redirect import
// ✅ Adds "base tab" redirects so TopNav bases never 404


import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import './App.css';

import Home from './Home';
import CourierDashboard from './Courier/CourierDashboard/CourierDashboard';
import CustomerDashboard from './Customer/CustomerDashboard/CustomerDashboard';

import AdminSignIn from './Admin/AdminSignIn';
import AdminDashboard from './Admin/AdminDashboard';
import AdminRouter from './Admin/AdminRouter';


import CustomerSignIn from './Customer/CustomerAuth/CustomerSignIn';
import CustomerSignUp from './Customer/CustomerAuth/CustomerSignUp';
import CourierSignIn from './Courier/CourierAuth/CourierSignIn';
import CourierSignUp from './Courier/CourierAuth/CourierSignUp';
import ResetPassword from './ResetPassword';
import ForgotPassword from './ForgotPassword'; 

import ProfileManagementCustomer from './Customer/CustomerDashboard/ProfileManagement/ProfileManagementCustomer';
import CustomerPaymentManagement from './Customer/CustomerDashboard/ProfileManagement/CustomerPaymentManagement';
import OrderHistory from './Customer/CustomerDashboard/ProfileManagement/OrderHistory';
import CustomerNotifications from './Customer/CustomerDashboard/ProfileManagement/CustomerNotifications';
import CustomerFeedbackAndRatings from './Customer/CustomerDashboard/ProfileManagement/CustomerFeedbackAndRatings';
import SupportAndHelpCenter from './Customer/CustomerDashboard/ProfileManagement/SupportAndHelpCenter';

import ProfileManagementCourier from './Courier/CourierDashboard/ProfileManagement/ProfileManagement'; // Updated import path
import CourierProfile from './Courier/CourierDashboard/ProfileManagement/CourierProfile';
import EmergencyAssistance from './Courier/CourierDashboard/ProfileManagement/EmergencyAssistance';
import CourierNotifications from './Courier/CourierDashboard/ProfileManagement/CourierNotifications';
import OrderManagement from './Courier/CourierDashboard/ProfileManagement/OrderManagement';
import PaymentAndInvoicing from './Courier/CourierDashboard/ProfileManagement/PaymentAndInvoicing';
import PerformanceAnalytics from './Courier/CourierDashboard/ProfileManagement/PerformanceAnalytics';
import ProofOfDelivery from './Courier/CourierDashboard/ProfileManagement/ProofOfDelivery';
import SettingsAndPreferences from './Courier/CourierDashboard/ProfileManagement/SettingsAndPreferences';
import ShiftScheduling from './Courier/CourierDashboard/ProfileManagement/ShiftScheduling';
import SupportAndHelpCenterCourier from './Courier/CourierDashboard/ProfileManagement/SupportAndHelpCenterCourier';
import VehicleMaintenance from './Courier/CourierDashboard/ProfileManagement/VehicleMaintenance';
import CourierLanguageAndLocalization from './Courier/CourierDashboard/ProfileManagement/CourierLanguageAndLocalization';
import Logout from './Courier/CourierDashboard/ProfileManagement/Logout';
import DeliveryRoutes from './Courier/CourierDashboard/ProfileManagement/DeliveryRoutes';
import AvailableOrders from './Courier/CourierDashboard/ProfileManagement/AvailableOrders';
import ProofOfDeliveryViewer from './Courier/CourierDashboard/ProfileManagement/ProofOfDeliveryViewer';
import CourierReferrals from './Courier/CourierDashboard/ProfileManagement/CourierReferrals';


import KnowledgeBase from './Customer/CustomerDashboard/ProfileManagement/KnowledgeBase';
import CommunityForums from './Customer/CustomerDashboard/ProfileManagement/CommunityForums';
import GettingStartedGuides from './Customer/CustomerDashboard/ProfileManagement/GettingStartedGuides';
import LanguageAndLocalization from './Customer/CustomerDashboard/ProfileManagement/LanguageAndLocalization';
import LiveChat from './Customer/CustomerDashboard/ProfileManagement/LiveChat';
import OrderCustomization from './Customer/CustomerDashboard/ProfileManagement/OrderCustomization';
import ProductDocumentation from './Customer/CustomerDashboard/ProfileManagement/ProductDocumentation';
import PromotionsAndDiscounts from './Customer/CustomerDashboard/ProfileManagement/PromotionsAndDiscounts';
import Recommendations from './Customer/CustomerDashboard/ProfileManagement/Recommendations';
import ReferralProgram from './Customer/CustomerDashboard/ProfileManagement/ReferralProgram';
import SocialSharing from './Customer/CustomerDashboard/ProfileManagement/SocialSharing';
import SubscriptionManagement from './Customer/CustomerDashboard/ProfileManagement/SubscriptionManagement';
import TicketSystem from './Customer/CustomerDashboard/ProfileManagement/TicketSystem';
import VideoTutorials from './Customer/CustomerDashboard/ProfileManagement/VideoTutorials';
import TrackPackage from './Customer/CustomerDashboard/ProfileManagement/TrackPackage';
import CustomerSettingsAndPreferences from './Customer/CustomerDashboard/ProfileManagement/CustomerSettingsAndPreferences';
import CustomerCourierCommunication from './Customer/CustomerDashboard/ProfileManagement/CustomerCourierCommunication';
import CustomerProfile from './Customer/CustomerDashboard/CustomerProfile';
import CustomerLayout from './Customer/CustomerDashboard/CustomerLayout';

import OrderBidsAndNegotiations from './Customer/CustomerDashboard/ProfileManagement/OrderBidsAndNegotiations';
import NegotiationThread from './Customer/CustomerDashboard/ProfileManagement/NegotiationThread';
import CourierNegotiationThread from './Courier/CourierDashboard/ProfileManagement/CourierNegotiationThread';

import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import CancellationPolicy from './pages/CancellationPolicy';
import AcceptableUsePolicy from './pages/AcceptableUsePolicy';
import Disclaimer from './pages/Disclaimer';
import CustomerAgreement from './pages/CustomerAgreement';
import BusinessCustomerAgreement from './pages/BusinessCustomerAgreement';
import CarrierAgreement from './pages/CarrierAgreement';

import ProtectedRoute from './Shared/ProtectedRoute';
import LegalFooter from './Shared/LegalFooter';

function App() {
  const handleCourierSignIn = (email, password) => {
    console.log('Signing in with:', email, password);
  };

  return (
    <div className="App">
       {/* ✅ Wrap Switch with Router  */}
      <Router>
        <Switch>
          {/* Customer Authentication */}
          <Route path="/" exact component={Home} />
          <Route path="/reset-password/:token" exact component={ResetPassword} />
          <Route path="/customer/sign-up" exact component={CustomerSignUp} />
          <Route path="/customer/sign-in" exact component={CustomerSignIn} />

          <Route path="/forgot-password" exact component={ForgotPassword} />

          {/* Courier Authentication */}
          <Route path="/courier/sign-up" exact component={CourierSignUp} />
          <Route path="/courier/sign-in" exact render={() => <CourierSignIn />} />

          {/* Admin Sign In */}
          <Route path="/admin/sign-in" component={AdminSignIn} />

          {/* Admin Dashboard */}
          <Route path="/admin" component={AdminRouter} />


          {/* Courier Dashboard */}
          <Route path="/courier/dashboard" exact component={CourierDashboard} />

          {/* Customer Dashboard */}
          <Route path="/customer/dashboard" exact component={CustomerDashboard} />

          <Route path="/terms" component={TermsOfService} />
<Route path="/privacy" component={PrivacyPolicy} />
<Route path="/refund-policy" component={RefundPolicy} />
<Route path="/cancellation-policy" component={CancellationPolicy} />
<Route path="/acceptable-use" component={AcceptableUsePolicy} />
<Route path="/disclaimer" component={Disclaimer} />
<Route path="/customer-agreement" component={CustomerAgreement} />
<Route path="/business-customer-agreement" component={BusinessCustomerAgreement} />
<Route path="/carrier-agreement" component={CarrierAgreement} />

          {/* =========================================================
              ✅ BASE ROUTES for TopNav tabs (never dead links)
              These do NOT duplicate my existing "long" routes.
              They are new entry points.
          ========================================================= */}
          <Route
            path="/customer/orders"
            exact
            render={() => <Redirect to="/customer/track-package" />}
          />
          <Route
            path="/customer/payments"
            exact
            render={() => <Redirect to="/customer/payment-management" />}
          />
          <Route
            path="/customer/messages"
            exact
            render={() => <Redirect to="/customer/customer-notifications" />}
          />
          <Route
            path="/customer/help"
            exact
            render={() => <Redirect to="/customer/support-and-help-center" />}
          />
          <Route
            path="/customer/account"
            exact
            render={() => <Redirect to="/customer/customer-settings-and-preferences" />}
          />

          <Route
          path="/courier/work"
          exact
          render={() => <Redirect to="/courier/available-orders" />}
          />

<Route
  path="/courier/earnings"
  exact
  render={() => <Redirect to="/courier/payment-and-invoicing" />}
/>

<Route
  path="/courier/messages"
  exact
  render={() => <Redirect to="/courier/dashboard" />}
/>

<Route
  path="/courier/help"
  exact
  render={() => <Redirect to="/courier/support-and-help-center-courier" />}
/>

<Route
  path="/courier/account"
  exact
  render={() => <Redirect to="/courier/courier-profile" />}
/>

<Route
  path="/courier/proof-of-delivery-view/:orderId"
  component={ProofOfDeliveryViewer}
/>


          {/* Courier base routes (TopNav) */}
          <Route
            path="/courier/available-loads"
            exact
            render={() => <Redirect to="/courier/available-orders" />}
          />
          <Route
            path="/courier/payment-invoicing"
            exact
            render={() => <Redirect to="/courier/payment-and-invoicing" />}
          />
          <Route
            path="/courier/notifications"
            exact
            render={() => <Redirect to="/courier/dashboard" />}
          />
          <Route
            path="/courier/support-help"
            exact
            render={() => <Redirect to="/courier/support-and-help-center-courier" />}
          />
          <Route
            path="/courier/profile"
            exact
            render={() => <Redirect to="/courier/courier-profile" />}
          />

          {/* =========================================================
              ✅ ALIAS ROUTES so navigation.config.js "short" paths work
              without deleting or renaming your existing routes.
              This prevents broken links in SectionNav.
          ========================================================= */}

          {/* Customer aliases */}
          <Route
  path="/customer/customer-profile"
  exact
  render={() => (
    <CustomerLayout>
      <CustomerProfile />
    </CustomerLayout>
  )}
/>

          <Route path="/customer/notifications" exact component={CustomerNotifications} />
          <Route path="/customer/support-help" exact component={SupportAndHelpCenter} />
          <Route path="/customer/settings-preferences" exact component={CustomerSettingsAndPreferences} />
          <Route path="/customer/language-localization" exact component={LanguageAndLocalization} />
          <Route path="/customer/feedback-ratings" exact component={CustomerFeedbackAndRatings} />
          <Route path="/customer/promotions-discounts" exact component={PromotionsAndDiscounts} />
          <Route path="/customer/courier-communication" exact component={CustomerCourierCommunication} />

          {/* Courier aliases */}
          <Route path="/courier/settings-preferences" exact component={SettingsAndPreferences} />
          <Route path="/courier/language-localization" exact component={CourierLanguageAndLocalization} />

          {/* Profile Management (kept — not deleted) */}
          <Route path="/customer/profile-management" exact component={ProfileManagementCustomer} />
          <Route path="/courier/profile-management" exact render={() => <Redirect to="/courier/profile" />} />


          {/* Customer Payment Management */}
          <Route path="/customer/payment-management" exact component={CustomerPaymentManagement} />

          {/* Customer Order History */}
          <Route path="/customer/order-history" exact component={OrderHistory} />

          {/* Customer: Order bids & negotiations hub */}
          <Route path="/customer/orders/:orderId/bids" exact component={OrderBidsAndNegotiations} />

          {/* Customer: Negotiation thread */}
          <Route path="/customer/negotiations/thread/:threadId" exact component={NegotiationThread} />

          {/* Courier: Negotiation thread */}
          <Route path="/courier/negotiations/thread/:threadId" exact component={CourierNegotiationThread} />


          {/* Notifications (your original long paths — kept) */}
          <Route path="/customer/customer-notifications" exact component={CustomerNotifications} />
          <Route path="/courier/courier-notifications" exact component={CourierNotifications} />

          {/* Customer Feedback & Ratings (your original long path — kept) */}
          <Route path="/customer/feedback-and-ratings" exact component={CustomerFeedbackAndRatings} />

          {/* Customer Support & Help Center (your original long path — kept) */}
          <Route path="/customer/support-and-help-center" exact component={SupportAndHelpCenter} />

          {/* Customer Knowledge Base */}
          <Route path="/customer/knowledge-base" exact component={KnowledgeBase} />

          {/* Customer Community Forums */}
          <Route path="/customer/community-forums" exact component={CommunityForums} />

          {/* Customer Getting Started Guides */}
          <Route path="/customer/getting-started-guides" exact component={GettingStartedGuides} />

          {/* Customer Language & Localization (your original long path — kept) */}
          <Route path="/customer/language-and-localization" exact component={LanguageAndLocalization} />

          {/* Customer Live Chat */}
          <Route path="/customer/live-chat" exact component={LiveChat} />

          {/* Customer Order Customization */}
          <Route path="/customer/order-customization" exact component={OrderCustomization} />

          {/* Customer Product Documentation */}
          <Route path="/customer/product-documentation" exact component={ProductDocumentation} />

          {/* Customer Promotions & Discounts (your original long path — kept) */}
          <Route path="/customer/promotions-and-discounts" exact component={PromotionsAndDiscounts} />

          {/* Customer Recommendations */}
          <Route path="/customer/recommendations" exact component={Recommendations} />

          {/* Customer Referral Program */}
          <Route path="/customer/referral-program" exact component={ReferralProgram} />

          {/* Customer Social Sharing */}
          <Route path="/customer/social-sharing" exact component={SocialSharing} />

          {/* Customer Subscription Management */}
          <Route path="/customer/subscription-management" exact component={SubscriptionManagement} />

          {/* Customer Ticket System */}
          <Route path="/customer/ticket-system" exact component={TicketSystem} />

          {/* Customer Video Tutorials */}
          <Route path="/customer/video-tutorials" exact component={VideoTutorials} />

          {/* Customer Track Package */}
          <Route path="/customer/track-package" exact component={TrackPackage} />

          {/* Customer Settings & Preferences (your original long path — kept) */}
          <Route path="/customer/customer-settings-and-preferences" exact component={CustomerSettingsAndPreferences} />

          {/* Customer Courier Communication (your original long path — kept) */}
          <Route path="/customer/customer-courier-communication" exact component={CustomerCourierCommunication} />

          {/* Courier Profile (your original long path — kept) */}
          <Route path="/courier/courier-profile" exact component={CourierProfile} />

          {/* Courier Emergency Assistance */}
          <Route path="/courier/emergency-assistance" exact component={EmergencyAssistance} />

          {/* Courier Order Management */}
          <Route path="/courier/order-management" exact component={OrderManagement} />

          {/* Courier Payment & Invoicing (your original long path — kept) */}
          <Route path="/courier/payment-and-invoicing" exact component={PaymentAndInvoicing} />

          {/* Courier Delivery Routes */}
          <Route path="/courier/delivery-routes" exact component={DeliveryRoutes} />

          {/* Courier Performance Analytics */}
          <Route path="/courier/performance-analytics" exact component={PerformanceAnalytics} />

          {/* Proof of Delivery */}
          <Route path="/courier/proof-of-delivery" exact component={ProofOfDelivery} />
          <Route path="/courier/proof-of-delivery/:orderId" exact component={ProofOfDelivery} />

          {/* Courier Settings & Preferences (your original long path — kept) */}
          <Route path="/courier/settings-and-preferences" exact component={SettingsAndPreferences} />

          {/* Courier Shift Scheduling */}
          <Route path="/courier/shift-scheduling" exact component={ShiftScheduling} />

          {/* Courier Support & Help Center (your original long path — kept) */}
          <Route path="/courier/support-and-help-center-courier" exact component={SupportAndHelpCenterCourier} />

          {/* Courier Vehicle Maintenance */}
          <Route path="/courier/vehicle-maintenance" exact component={VehicleMaintenance} />

          {/* Courier Language & Localization (your original long path — kept) */}
          <Route path="/courier/courier-language-and-localization" exact component={CourierLanguageAndLocalization} />

          {/* Courier Logout */}
          <Route path="/courier/logout" exact component={Logout} />

          {/* Available Orders / Unassigned Orders */}
          <Route path="/courier/available-orders" exact component={AvailableOrders} />

          {/* Driver/Carrier Referrals */}
          <Route path="/courier/referrals" component={CourierReferrals} />

          {/* (Optional) Catch-all */}
          {/* <Route render={() => <Redirect to="/" />} /> */}
        </Switch>
          <LegalFooter />
      </Router>
    </div>
  );
}

export default App;
